module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av258-be8c80e7ad55a906c3d937fbd8297920.jpg";